// src/store/index.js
import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // uses localStorage by default
import rootReducer from "./reducers";
import rootSaga from "./sagas";

const persistConfig = {
  key: 'root', // top-level key in storage
  storage,
  // whitelist: ['user'], // Only this reducer is persisted
  blacklist: ['user', 'Layout', 'storeMenu', 'storeDetails', 'imageMap'], // These reducer won't be persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);
export default store;
